import type ConversationAttachmentWellViewState from '../schema/ConversationAttachmentWellViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'sortConversationAttachmentWell',
    function sortConversationAttachmentWell(
        conversationAttachmentWell: ConversationAttachmentWellViewState,
        newestOnBottom: boolean
    ): void {
        conversationAttachmentWell.docViewAttachments = conversationAttachmentWell.docViewAttachments.sort(
            (a, b) => {
                return (
                    (newestOnBottom ? 1 : -1) *
                    (new Date(
                        conversationAttachmentWell.itemReceivedTimeMap[a.attachmentId.Id]
                    ).getTime() -
                        new Date(
                            conversationAttachmentWell.itemReceivedTimeMap[b.attachmentId.Id]
                        ).getTime())
                );
            }
        );
    }
);
